import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GroupModalComponent} from './group-modal.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ErrorMsgModule} from '../../error-msg/error-msg.module';
import {ClickOutsideModule} from '../../../directives/clickOutside/clickOutside.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ClickOutsideModule,
    ErrorMsgModule
  ],
  declarations: [GroupModalComponent],
  exports: [GroupModalComponent]
})
export class GroupModalModule {
}
